import {session, local} from 'wix-storage';




$w.onReady(function () {
$w("#html1").onMessage( (event) => {
  let receivedData = event.data;
  console.log('received message', receivedData);
	if (receivedData && receivedData === 'rvModal') {
        $w("#html1").scrollTo();
	}
  else if (receivedData && receivedData === 'rvReady') {
    const value = JSON.parse(session.getItem("rvWixCart")) || { card: [], pass: [], free:[], subscription:[]};
    const tok = session.getItem('rvWixKey') || local.getItem('rvWixKey') || 'wix-key-not-defined';
    const x = {token: tok, cart: value};
    $w("#html1").postMessage(JSON.stringify({message: 'rvExtInitialize', data: x}));
	}
  else if(receivedData && receivedData.message === 'rvToken')
  {
    // figure out wheree to store base on customers current or previous preference
    const check = local.getItem('rvWixKey');
    if((typeof receivedData.persist !== 'undefined' && receivedData.persist === 1) || 
       (typeof receivedData.persist !== 'undefined' && receivedData.persist === 2 && typeof check !== 'undefined' ))
      local.setItem('rvWixKey', receivedData.value);
    else 
      session.setItem('rvWixKey', receivedData.value);
  }
  else if(receivedData && receivedData.message === 'rvCart')
  {
    session.setItem('rvWixCart', receivedData.value);
  }
  

} );
});
